'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { useEffect } from 'react';

import { usePathname } from '@/i18n/navigation';
import { LocationDto } from '@/lib/locations';

type LocationEventsProps = {
  location: LocationDto;
};

export default function LocationEvents({ location }: LocationEventsProps) {
  const pathname = usePathname();
  useEffect(() => {
    const gtmOptions = {
      location_name: location.name,
      location_city: location.city,
      location_metro: location.metroName,
      location_country: location.country,
      location_id: location.id,
    };

    sendGTMEvent({
      event: 'pageview',
      url: pathname,
      pageType: 'location',
      ...gtmOptions,
    });
  }, []);

  return null;
}
